<template>
  <b-modal
    ref="modal"
    size="lg"
    title="Create View Permission"
    title-class="font-18"
    hide-footer
    :no-close-on-backdrop="true"
    @hidden="$emit('hidden')"
  >
    <validationObserver ref="createView">
      <b-form @submit.prevent="onSubmit">
        <validationProvider
          v-slot="{ errors }"
          name="View Name"
          :rules="{
            required: true,
            duplicateName: [isDuplicateViewName, 'View Name is duplicate'],
          }"
        >
          <b-form-group
            label="View Name"
            label-for="viewName"
            label-cols-sm="3"
          >
            <b-form-input
              id="viewNameEN"
              type="text"
              v-model="input.view_name"
              :class="{ 'is-invalid': errors.length }"
              @keyup="checkDuplicateName(input.view_name, '')"
            ></b-form-input>
            <div v-if="errors.length" class="validate-invalid">
              <span>{{ errors[0] }}</span>
            </div>
          </b-form-group>
        </validationProvider>
        <hr/>
        <validationProvider
          v-slot="{ errors }"
          name="Display Name(EN)"
          :rules="{
            required: true,
            duplicateName: [isDuplicateEN, 'Display Name(EN) is duplicate'],
          }"
        >
          <b-form-group
            label="Display Name(EN)"
            label-for="displayNameEN"
            label-cols-sm="3"
          >
            <b-form-input
              id="displayNameEN"
              type="text"
              v-model="input.display_name.en"
              :class="{ 'is-invalid': errors.length }"
              @keyup="checkDuplicateName(input.display_name.en, 'en')"
            ></b-form-input>
            <div v-if="errors.length" class="validate-invalid">
              <span>{{ errors[0] }}</span>
            </div>
          </b-form-group>
        </validationProvider>

        <validationProvider
          v-slot="{ errors }"
          name="Display Name(TH)"
          :rules="{
            required: true,
            duplicateName: [isDuplicateTH, 'Display Name(TH) is duplicate'],
          }"
        >
          <b-form-group
            label="Display Name(TH)"
            label-for="displayNameTH"
            label-cols-sm="3"
          >
            <b-form-input
              id="displayNameTH"
              type="text"
              v-model="input.display_name.th"
              :class="{ 'is-invalid': errors.length }"
              @keyup="checkDuplicateName(input.display_name.th, 'th')"
            ></b-form-input>
            <div v-if="errors.length" class="validate-invalid">
              <span>{{ errors[0] }}</span>
            </div>
          </b-form-group>
        </validationProvider>
        <hr/>
        <validationProvider
          v-slot="{ errors }"
          name="Route Name"
          :rules="{ required: true }"
        >
          <b-form-group
            class="mb-4"
            label="Route Name"
            label-for="route-name-input"
            label-cols-sm="3"
          >
            <b-form-input
              id="route-name-input"
              v-model="input.route_name"
              :class="{ 'is-invalid': errors.length }"
            ></b-form-input>
            <div v-if="errors.length" class="validate-invalid">
              <span>{{ errors[0] }}</span>
            </div>
          </b-form-group>
        </validationProvider>

        <b-form-group
          class="mb-4"
          label="Route Url"
          label-for="route-url-input"
          label-cols-sm="3"
        >
          <b-form-input
            id="route-url-input"
            v-model="input.route_url"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          class="mb-4"
          label="Visible"
          label-for="visible"
          label-cols-sm="3"
        >
          <div class="radio-inline">
            <b-form-radio
              v-model="input.is_visible"
              class="custom-radio mb-3"
              :value="true"
              >Show</b-form-radio
            >
            <b-form-radio
              v-model="input.is_visible"
              class="custom-radio mb-3"
              :value="false"
              >Hide</b-form-radio
            >
          </div>
        </b-form-group>

        <b-form-group
          class="mb-4"
          label="Is Title"
          label-for="visible"
          label-cols-sm="3"
        >
          <div class="radio-inline">
            <b-form-radio
              v-model="input.is_title"
              class="custom-radio mb-3"
              :value="true"
              >Yes</b-form-radio
            >
            <b-form-radio
              v-model="input.is_title"
              class="custom-radio mb-3"
              :value="false"
              >No</b-form-radio
            >
          </div>
        </b-form-group>

        <b-form-group
          class="mb-4"
          label="Glyphicon"
          label-for="glyphicon-input"
          label-cols-sm="3"
        >
          <b-form-input
            id="glyphicon-input"
            v-model="input.icon"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          class="mb-4"
          label="Sequence"
          label-for="sequence"
          label-cols-sm="3"
        >
          <b-form-input id="sequence" v-model="input.sequence"></b-form-input>
        </b-form-group>

        <b-form-group
          class="mb-4"
          label="Command ID"
          label-for="commandId"
          label-cols-sm="3"
        >
          <b-form-input
            id="commandId"
            v-model="input.command_id"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          class="mb-4"
          label="View Type"
          label-for="viewType"
          label-cols-sm="3"
        >
          <div class="radio-inline">
            <b-form-radio
              v-model="input.device_type"
              class="custom-radio mb-3"
              value="All"
              >All</b-form-radio
            >
            <b-form-radio
              v-model="input.viewType"
              class="custom-radio mb-3"
              value="Web"
              >Web</b-form-radio
            >
            <b-form-radio
              v-model="input.viewType"
              class="custom-radio mb-3"
              value="Mobile"
              >Mobile</b-form-radio
            >
          </div>
        </b-form-group>
        <validationProvider
          v-slot="{ errors }"
          name="View Status"
          :rules="{ required: true }"
        >
          <b-form-group
            class="mb-4"
            label="View Status"
            label-for="viewStatus"
            label-cols-sm="3"
          >
            <multiselect
              v-model="input.status"
              :options="viewStatus"
              :class="{ 'is-invalid': errors.length }"
            ></multiselect>
            <div v-if="errors.length" class="validate-invalid">
              <span>{{ errors[0] }}</span>
            </div>
          </b-form-group>
        </validationProvider>
        <button type="submit" class="btn btn-primary mr-1" style="float: right">
          Submit
        </button>
      </b-form>
    </validationObserver>
  </b-modal>
</template>
<script>
import Multiselect from "vue-multiselect";
import viewProvider from "@/helpers/service/view-provider";
export default {
  components: {
    Multiselect,
  },
  props: {
    activeModal: {
      type: Boolean,
      default: false,
    },
    applicationId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      openModal: false,
      input: {
        view_name: "",
        display_name: {
          th: '',
          en: ''
        },
        sequence: 0,
        route_name: "",
        route_url: "",
        icon: "",
        status: "Active",
        is_visible: true,
        is_title: false,
        command_id: "",
        device_type: "All",
      },
      viewStatus: ["Active", "Delete"],
      isDuplicateEN: false,
      isDuplicateTH: false,
      isDuplicateViewName: false
    };
  },
  watch: {
    activeModal: function (value) {
      if (value) this.$refs.modal.show();
      else {
        console.log("close");
        this.$refs.modal.hide();
        this.onClear();
      }
    },
  },
  methods: {
    onClear() {
      this.input = {
        view_name: "",
        display_name: {
          th: '',
          en: ''
        },
        sequence: 0,
        route_name: "",
        route_url: "",
        icon: "",
        status: "Active",
        is_visible: true,
        is_title: false,
        command_id: "",
        device_type: "All",
      };
    },
    async checkDuplicateName(viewName, lang) {
      const params = new URLSearchParams();
      if (lang == 'en') {
        params.append("display_name.en", viewName);
      } else if (lang == 'th') {
        params.append("display_name.th", viewName);
      } else {
        params.append("view_name", viewName);
      }
     
      let result = await viewProvider.checkDuplicateViewAsync(
        this.applicationId,
        params
      );
      if (result.status === 200) {
        if (lang == 'en') {
          this.isDuplicateEN = true;
        } else if (lang == 'th') {
          this.isDuplicateTH = true;
        } else {
          this.isDuplicateViewName = true;
        }
      } else if (result.response.status === 404) {
        if (lang == 'en') {
          this.isDuplicateEN = false;
        } else if (lang == 'th') {
          this.isDuplicateTH = false;
        } else {
          this.isDuplicateViewName = false;
        }
      }
    },
    onSubmit() {
      this.$refs.createView.validate().then((result) => {
        //console.log(result);
        if (result) this.$emit("createView", this.input);
      });
    },
  },
};
</script>
